module.exports = __webpack_public_path__ + "static/media/participation.1da81e22.svg";